import { FooterLayout, FooterSignalProps } from '@eventbrite/timed-entry';
import React, { FC } from 'react';
import {
    DEFAULT_STYLES,
    getStyles,
    REBRANDING_STYLES,
} from '../../../../utils/rebrand';
import { DiscountSvg } from '../../assests/DiscountSvg';
import { DiscountSvgRebrand } from '../../assests/DiscountSvgRebrand';
import commonStyles from './DiscountFooter.common.module.scss';
import defaultStyles from './DiscountFooter.module.scss';
import rebrandStyles from './DiscountFooter.rebranding.module.scss';

const stylesModules = {
    [DEFAULT_STYLES]: defaultStyles,
    [REBRANDING_STYLES]: rebrandStyles,
};
interface DiscountFooterProps {
    discount: string;
    isAppRebrandActive: boolean;
}

const DiscountFooter: FC<DiscountFooterProps> = ({
    discount,
    isAppRebrandActive,
}) => {
    const theme = getStyles(isAppRebrandActive);
    const styles = stylesModules[theme];
    const footerSignals: FooterSignalProps[] = [
        {
            icon: isAppRebrandActive ? <DiscountSvgRebrand /> : <DiscountSvg />,
            className: styles.discountIconWrapper,
            text: discount,
        },
    ];

    return (
        <div
            className={commonStyles.discountWrapper}
            data-testid="overall-discount"
        >
            <FooterLayout footerMetaData={footerSignals} />
        </div>
    );
};

export default DiscountFooter;
